// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-error-error-EAVuy {
  color: #F12626;
  font-size: 13px;
  font-weight: 500;
  margin-left: 4px;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/field-error/field-error.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".error {\n  color: #F12626;\n  font-size: 13px;\n  font-weight: 500;\n  margin-left: 4px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `field-error-error-EAVuy`
};
export default ___CSS_LOADER_EXPORT___;
